<template>
  <div class="chart-container">
    <canvas id="area-chart" width="100%"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js';

export default {
  name: 'AreaChart',
  props: {

    fullStats: {
      type: Object,
      required: true
    },

  },
  data() {
    return {
      chartInstance: null,
    };
  },
  mounted() {
    const ctx=document.getElementById('area-chart').getContext('2d');
    // Ordina le chiavi in ordine decrescente
    const sortedEntries=Object.entries(this.fullStats?.remote_stats.stats_per_date).sort(([a], [b]) => new Date(a)-new Date(b));
    const sortedData=Object.fromEntries(sortedEntries);




    this.chartInstance=new Chart(ctx, {
      type: 'line',
      data: {
        labels: Object.keys(sortedData).map(
          (value) => { return this.$moment(value).format('DD/MM/YY') }
        ),
        datasets: [
          {
            label: 'Num. Connections',
            data: Object.values(sortedData).map(
              (value) => { return value.count }
            ),
            backgroundColor: 'rgba(0, 80, 239, 0.1)',
            borderColor: 'rgba(0, 80, 239, 0.5)',
            borderWidth: 2,
            yAxisID: 'y-axis-connections',
            fill: true,
            lineTension: 0.5,
          },
          {
            label: 'Total Time (min)',
            data: Object.values(sortedData).map(
              (value) => { return (Math.round((value.total_time)/60)) }
            ),
            backgroundColor: 'rgba(0, 80, 239, 0.1)',
            borderColor: 'rgba(0, 80, 239, 0.5)',
            borderWidth: 2,
            yAxisID: 'y-axis-minutes',
            fill: true,
            lineTension: 0.5,
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: false
        },
        animation: {
          onComplete: function() {
            const chartInstance=this.chart;
            const ctx=chartInstance.ctx;
            ctx.font=Chart.helpers.fontString(12, 'normal', 'Poppins');
            ctx.fillStyle='#000';
            ctx.textAlign='center';
            ctx.textBaseline='bottom';

            this.data.datasets.forEach(function(dataset, i) {
              const meta=chartInstance.controller.getDatasetMeta(i);
              meta.data.forEach(function(bar, index) {
                const data=dataset.data[index];
                if (data!=0) {
                  ctx.fillText(data, bar._model.x-10, bar._model.y+5);
                }
              });
            });
          }
        },
        scales: {
          yAxes: [
            {
              id: 'y-axis-connections',
              type: 'linear',
              position: 'left',
              ticks: {
                beginAtZero: true,
              },
              scaleLabel: {
                display: true,
                labelString: this.$t('Num. Connessioni')
              }
            },
            {
              id: 'y-axis-minutes',
              type: 'linear',
              position: 'right',
              ticks: {
                beginAtZero: true,
              },
              scaleLabel: {
                display: true,
                labelString: this.$t('Total Time (min)')
              },
              gridLines: {
                drawOnChartArea: false,
              }
            }
          ],
          xAxes: [
            {
              ticks: {
                autoSkip: false,
                maxRotation: 90,
                minRotation: 90,
              }
            }
          ]
        },
        legend: {
          display: false
        }
      }
    });

    window.addEventListener('resize', this.resize);

  },
  beforeDestroy(){
    window.removeEventListener('resize', this.resize);
  },
  methods:{
    resize(){
 if (this.chartInstance) {
        this.chartInstance.resize();
      }
    }
  }
};
</script>
<style scoped>
.chart-container {
  position: relative;
  width: 100%;
  height: 250px;
  /* o 'auto' se vuoi che si adatti anche in altezza */
}

canvas {
  width: 100% !important;
  height: 100% !important;
}
</style>
